import { UploadOutlined, LinkedinOutlined, GithubFilled } from '@ant-design/icons';
import { Button, Popconfirm, Space, Upload, Col, Row, Divider, Card, Avatar, Typography, List, Anchor} from 'antd';
import React from 'react';
import Career from './Career'

const { Meta } = Card;
const { Title, Text } = Typography;
const { Link } = Anchor;

const data1 = [
    // languages
    {'title':'Python','src':'asset/Python.png.png'},
    {'title':'Bash','src':'asset/Bash.png.png'},
    {'title':'Golang','src':'asset/Golang.png.png'}
]
const data2 = [
    // databases
    {'title':'Mysql','src':'asset/MySQL.png.png'},
    {'title':'Redis','src':'asset/Redis.png.png'}
]

const data3_aws = [
    // databases
    {'title':'EC2','src':'asset/Ec2.png'},
    {'title':'RDS','src':'asset/RDS.png'},
    {'title':'SSM','src':'asset/SSM.JPG'},
    {'title':'S3','src':'asset/S3.png'},
    {'title':'CloudFront   ','src':'asset/Cloudfront.png'},
    {'title':'Athena','src':'asset/Athena.PNG'},
    {'title':'Glue','src':'asset/Glue.PNG'},
    {'title':'SNS','src':'asset/SNS.jpg'},
    {'title':'SQS','src':'asset/SQS.PNG'},
    {'title':'CloudWatch','src':'asset/Cloudwatch.PNG'},
]

const data4_systems = [
    
    {'title':'Linux Administration','src':'asset/LinuxAdmin.PNG'},
    {'title':'Filesystem','src':'asset/Filesystem.PNG'},
    {'title':'Memory Management','src':'asset/Memory.PNG'},
    {'title':'TCP/IP','src':'asset/TCP.png'},
    {'title':'DNS','src':'asset/DNS.PNG'},
    {'title':'L3/L4/L7 Loadbalancing','src':'asset/LB.PNG'},
    {'title':'SMTP','src':'asset/SMTP.PNG'},
    {'title':'IMAP','src':'asset/IMAP.PNG'},
]

const data_infrastructure_tools = [
    {'title':'Saltstack','src':'asset/Salt.PNG'},
    {'title':'Terraform','src':'asset/Terraform.jpg'},
    {'title':'Shinken','src':'asset/Shinken.PNG'},
    {'title':'Prometheus','src':'asset/Prometheus.PNG'},
    {'title':'Kubernetes','src':'asset/Kubernetes.PNG'},
    {'title':'Docker','src':'asset/Docker.PNG'},
    {'title':'Docker Compose','src':'asset/Dockercompose.PNG'},
    {'title':'HAProxy','src':'asset/HAproxy.PNG'},
    {'title':'Nginx','src':'asset/Nginx.PNG'},
    {'title':'ELK Stack','src':'asset/ELK.PNG'},
    {'title':'Grafana','src':'asset/Grafana.PNG'}
]

const data_web = [
    {'title': 'Flask','src':'asset/Flask.jpg'},
    {'title': 'React(Moderate)','src':'asset/React.PNG'},
    {'title': 'Flask Restful','src':'asset/Flaskrestful.PNG'}
]

const data_cicd = [
    {'title': 'Jenkins','src':'asset/Jenkins.PNG'},
    {'title': 'Travis CI','src':'asset/Travis.JPG'},
]

const Profile = () => {
    
    return (<>
        <div>
        <Row>
        <Col>
        
        <Card
                style={{
                width:'small',
                marginTop: 16,
                }}
            >
        <Meta
          avatar={<Avatar size={150} src="http://krishnak9.github.io/images/kk.jpg" />}
          title="About Me"
          description="DevOps / Site Reliability Engineer with 4 years of experience in Linux Systems, Automation, Networking, Cloud and Software Engineering..
          I have deep interest in computer system/software engineering, opensource , Linux and Networking. I think in terms of holistic design of the systems and always works towards lygometric thinking. I find having a deep sense of learning and exploration towards problem solving and simplifying complex tasks into smaller problems rewarding."
        />
        
       </Card>
       <Card>
        <Space>
                <a href='https://www.linkedin.com/in/krishna-kumar-09992311a/'><LinkedinOutlined /> LinkedIn</a>
                <a href='https://github.com/krishnak9'><GithubFilled /> Github </a>
       </Space>
       </Card>
        </Col>  
        {/* col ends  */}
        
        </Row>
       <Card>
       <Divider></Divider>
       <Row>
            <Title level={4}>Professional Experience</Title>
          
            
       </Row>
       
       <Row>
        
       <Col>
            <Card>
            <Career></Career>
            </Card>
              
        </Col>
       </Row>
       <Divider></Divider>
         <Row>
            <Title level={4}>Technologies/Skills</Title>
            
        </Row>
        <Divider></Divider>
        <i> I have worked on the following technologies and tools. </i>
        <Row>
            <Col> 
            <Card>
            <Title level={5}>Languages</Title>
            <List
   
                    dataSource={data1}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
             </Card>
            <Card>
            <Title level={5}>Web/Frameworks</Title>
            <List
   
                    dataSource={data_web}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
           

            </Card>
             
            <Card>
            <Title level={5}>DB/KVStores</Title>
            <List
   
                    dataSource={data2}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
            </Card>
            

            </Col>

            <Col> 
            <Card>
            <Title level={5}>AWS Cloud</Title>
            <Row><Col>
            <List
   
                    dataSource={data3_aws}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            
            )}
            />
            </Col>
            </Row>
            </Card>
             
                
            </Col>
            <Col>
            
            <Card>

            <Title level={5}>Systems</Title>
            <List
   
                    dataSource={data4_systems}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
            </Card>

            <Card>
            <Title level={5}>CI/CD Tools</Title>
            <List
   
                    dataSource={data_cicd}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
            </Card>

            </Col>
              


            <Col> 
            <Card>
            <Title level={5}>Infrastructure Tools</Title>
            <List
   
                    dataSource={data_infrastructure_tools}
                    renderItem={item => (
                    <List.Item>
                        <Avatar src={process.env.PUBLIC_URL + item.src}></Avatar> {item.title}
                    </List.Item>
            )}
            />
            </Card>
             
                
            </Col>
        </Row>
        <Divider></Divider>
        
       </Card>

       
        </div>
        </>
    )
    };

export default Profile;